(function($) {

var pageId = 'page-cal-settings',
    page = '#' + pageId;

$(function() {
    $('body')
        .on( "click", page + " .link-cal-color", function(e) {
            e.preventDefault();
            var link = $(this).addClass("selected");
            var form = link.closest(".form");

            link.siblings(".link-cal-color")
                .removeClass("selected");

            form.find("input[name=calendar_color]")
                .val(link.data("color"));
        })
        .on('ajax:beforeSend', page + ' form#form-edit-calendar', function(e, xhr, settings) {
            // set ajax param members
            var membersGuid = $('.member.selected').map(function() {
                return $(this).data('guid');
            }).get();

            membersGuid.push(tower.me.guid);

            var membersParam = '';
            $.each(membersGuid, function(i, guid) {
                membersParam += '&member_guids[]=' + guid;
            });

            settings.data += membersParam;
        })
        .on('ajax:success', page + ' .form#form-edit-calendar', function(e, result) {
            if (tower.calendars) {
                var calIndex = -1;
                $.each(tower.calendars, function(i, c) {
                    if (c.guid === result.calendar.guid) {
                        calIndex = i;
                        return false;
                    }
                });

                if (calIndex < 0) {
                    tower.calendars.push(result.calendar);
                } else {
                    tower.calendars[calIndex] = result.calendar;
                }
            }

            var eventFilter = simple.util.storage.get('calEventFilter_' + tower.team.guid);
            if (eventFilter) {
                var guids = eventFilter.split(',');
                if ($.inArray(result.calendar.guid, guids) < 0) {
                    guids.push(result.calendar.guid);
                    simple.util.storage.set('calEventFilter_' + tower.team.guid, guids.join(','));
                }
            } else {
                simple.util.storage.set('calEventFilter_' + tower.team.guid, result.calendar.guid);
            }

            if (location.search.indexOf('set_as_leave_calendar') > 0) {
                tower.stack.load('/teams/' + tower.team.guid + '/set_leave_calendar/', {
                    replace: true
                });
            } else {
                tower.stack.load('/teams/' + tower.team.guid + '/calendars/', {
                    root: true,
                    fluid: true
                });
            }
        });
});

$(document).on('pjaxload#' + pageId, function(e, $page, page) {
    var color = $page.find('input[name=calendar_color]').val();
    $page.find('.cal-colors .link-cal-color.cal-color-' + color).addClass('selected');

    tower.initManageMembers($page);
});

})(jQuery);
